import { render, staticRenderFns } from "./NftReward.vue?vue&type=template&id=3dba87e9&scoped=true&"
import script from "./NftReward.vue?vue&type=script&lang=ts&"
export * from "./NftReward.vue?vue&type=script&lang=ts&"
import style0 from "./NftReward.vue?vue&type=style&index=0&id=3dba87e9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba87e9",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QItem,QItemSection,QItemLabel,QSeparator,QCardSection,QCardActions,QBtnGroup,QBtn});
